export type JsonValue = unknown;

type Dict = Record<string, unknown>;
const isObj = (v: unknown): v is Dict => typeof v === 'object' && v !== null && !Array.isArray(v);
const num = (v: unknown, def: number) => (typeof v === 'number' && Number.isFinite(v) ? v : def);
const clamp01 = (x: number) => (x < 0 ? 0 : x > 1 ? 1 : x);

export type CropFractions = { left: number; top: number; right: number; bottom: number };
export type HotspotFractions = { x: number; y: number; width: number; height: number };

export function readCropFractions(j: JsonValue): CropFractions {
    const o = isObj(j) ? j : {};
    const left = clamp01(num(o.left, 0));
    const top = clamp01(num(o.top, 0));
    const right = clamp01(num(o.right, 0));
    const bottom = clamp01(num(o.bottom, 0));
    return { left, top, right, bottom };
}

export function readHotspotFractions(j: JsonValue): HotspotFractions {
    const o = isObj(j) ? j : {};
    const x = clamp01(num(o.x, 0.5));
    const y = clamp01(num(o.y, 0.5));
    const width = clamp01(num(o.width, 1));
    const height = clamp01(num(o.height, 1));
    return { x, y, width, height };
}
